import { useTheme } from '@mui/material/styles';

function NRJiraLowestPriorityIcon({ height = '24', width = '24', color }) {
  const theme = useTheme();
  const iconColor = color || theme.palette.jiraIntegration?.priorityColors?.lowest;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path d="M6 8L12 11L18 8" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 13L12 16L18 13" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default NRJiraLowestPriorityIcon;
